import React from 'react';
import { Switch, Grid } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';
import { CustomTooltip } from '@AMIEWEB/Common/Tooltips/CustomTooltip';
import { CSSProperties } from 'react';

const useStyles = makeStyles()(theme => ({
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
  },
  switchSelected: { paddingLeft: '15px' },
  switchUnselected: { paddingRight: '15px' },
  switchLightBlue: {
    '& .MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: `${theme.palette.secondary.main}`,
    },
    '& .MuiSwitch-track': {
      backgroundColor: `${theme.palette.system.backgroundGrey}`,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: `${theme.palette.secondary.main}`,
    },
  },
}));

interface SwitchFormComponentProps {
  name: string;
  label: string;
  onText?: string;
  offText: string;
  checkedValue?: boolean;
  tooltip?: string; // Make tooltip optional
  style?: CSSProperties;
  switchRowStyle?:string;
}

export const SwitchFormComponent: React.FC<SwitchFormComponentProps> = ({
  name,
  label,
  onText,
  offText,
  checkedValue,
  tooltip,
  style,
  switchRowStyle,
  ...rest
}) => {
  const { classes } = useStyles(); // Destructure classes from the result of useStyles
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={checkedValue}
      render={({ field: { onChange, value } }) => (
        <Grid className={switchRowStyle ? switchRowStyle : classes.switchRow}>
          <span style={style}>{label}</span>          
          {tooltip && <CustomTooltip tooltipContent={tooltip} placement={'bottom-start'}>
            <Switch
              checked={value}
              className={`${classes.switchLightBlue} ${value ? classes.switchSelected : classes.switchUnselected}`}
              onClick={() => {
                onChange(!value);
              }}
            />
          </CustomTooltip>}
          {!tooltip && (
            <Switch
              checked={value}
              className={`${classes.switchLightBlue} ${value ? classes.switchSelected : classes.switchUnselected}`}
              onClick={() => {
                onChange(!value);
              }}
            />
          )}
          {value ? onText : offText}
        </Grid>
      )}
    />
  );
};
